import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { reduxKey } from './constants';
import { setFirstTimeFlags, unsetFirstTimeFlag } from './actions';
import { handleActions } from 'redux-actions';
const actionHandlers = handleActions({
    [setFirstTimeFlags.toString()]: (state, { payload: flags  })=>_object_spread({}, state, flags),
    [unsetFirstTimeFlag.toString()]: (state, { payload: { flag  }  })=>_object_spread_props(_object_spread({}, state), {
            [flag]: false
        })
}, {});
export default {
    [reduxKey]: actionHandlers
};
